import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createRef, useEffect } from 'react';
import { Box, Container, TAGTypography, TAGSvgIcon, useMediaQuery, useTheme, TAGButton, Grid } from '../../';
import TermsAndConditions from './TermsAndConditions';
import FocalPointImage from './FocalPointImage';
import RichText from './RichText';

var Service = function Service(_ref) {
  var backgroundColor = _ref.backgroundColor,
      branding = _ref.branding,
      buttonText = _ref.buttonText,
      _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === void 0 ? 'Secondary Default' : _ref$buttonType,
      buttonUrl = _ref.buttonUrl,
      _ref$centerAlign = _ref.centerAlign,
      centerAlign = _ref$centerAlign === void 0 ? true : _ref$centerAlign,
      _ref$contained = _ref.contained,
      contained = _ref$contained === void 0 ? false : _ref$contained,
      description = _ref.description,
      direction = _ref.direction,
      eyebrow = _ref.eyebrow,
      focalPointImage = _ref.focalPointImage,
      image = _ref.image,
      imageLayout = _ref.imageLayout,
      _ref$mediaType = _ref.mediaType,
      mediaType = _ref$mediaType === void 0 ? 'Image' : _ref$mediaType,
      _ref$renderAsCards = _ref.renderAsCards,
      renderAsCards = _ref$renderAsCards === void 0 ? false : _ref$renderAsCards,
      richTextDescription = _ref.richTextDescription,
      tc = _ref.tc,
      title = _ref.title,
      video = _ref.video,
      videoImage = _ref.videoImage,
      youTubeVideoId = _ref.youTubeVideoId,
      youTubeVideoImage = _ref.youTubeVideoImage;
  var videoRef = createRef();
  var buttonRef = createRef();
  var theme = useTheme();
  var isSmall = useMediaQuery(theme.breakpoints.down('md'));
  var isDark = backgroundColor === 'dark';

  var playVideoClicked = function playVideoClicked() {
    var _videoRef$current, _videoRef$current2, _videoRef$current3;

    (_videoRef$current = videoRef.current) !== null && _videoRef$current !== void 0 && _videoRef$current.paused ? (_videoRef$current2 = videoRef.current) === null || _videoRef$current2 === void 0 ? void 0 : _videoRef$current2.play() : (_videoRef$current3 = videoRef.current) === null || _videoRef$current3 === void 0 ? void 0 : _videoRef$current3.pause();
  };

  var show = function show() {
    if (typeof buttonRef !== 'undefined' && typeof buttonRef.current !== 'undefined' && buttonRef.current !== null) {
      buttonRef.current.style.opacity = '0';
    }
  };

  var hide = function hide() {
    if (typeof buttonRef !== 'undefined' && typeof buttonRef.current !== 'undefined' && buttonRef.current !== null) {
      buttonRef.current.style.opacity = '1';
    }
  };

  useEffect(function () {
    var _videoRef$current4, _videoRef$current5;

    (_videoRef$current4 = videoRef.current) === null || _videoRef$current4 === void 0 ? void 0 : _videoRef$current4.addEventListener('playing', show);
    (_videoRef$current5 = videoRef.current) === null || _videoRef$current5 === void 0 ? void 0 : _videoRef$current5.addEventListener('pause', hide);
    return function () {
      var _videoRef$current6, _videoRef$current7;

      (_videoRef$current6 = videoRef.current) === null || _videoRef$current6 === void 0 ? void 0 : _videoRef$current6.removeEventListener('playing', show);
      (_videoRef$current7 = videoRef.current) === null || _videoRef$current7 === void 0 ? void 0 : _videoRef$current7.removeEventListener('pause', hide);
    };
  });
  var circleImageBorderStyles = {
    borderTopLeftRadius: isSmall && renderAsCards ? '8px' : '50%',
    borderTopRightRadius: isSmall && renderAsCards ? '8px' : '50%',
    borderBottomLeftRadius: isSmall && renderAsCards ? 0 : '50%',
    borderBottomRightRadius: isSmall && renderAsCards ? 0 : '50%'
  };
  var squareImageBorderStyles = {
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderBottomLeftRadius: isSmall ? renderAsCards ? 0 : '8px' : '8px',
    borderBottomRightRadius: isSmall ? renderAsCards ? 0 : '8px' : '8px'
  };
  var rectAngleImageBorderStyles = {
    borderTopLeftRadius: isSmall ? '8px' : direction === 'row' ? '152px' : 0,
    borderTopRightRadius: isSmall ? '8px' : direction === 'row-reverse' ? '152px' : 0,
    borderBottomLeftRadius: isSmall ? renderAsCards ? 0 : '8px' : 0,
    borderBottomRightRadius: isSmall ? renderAsCards ? 0 : '8px' : 0
  };

  var imageLayoutStyles = function imageLayoutStyles() {
    switch (imageLayout) {
      case 'circle':
        return circleImageBorderStyles;

      case 'square':
        return squareImageBorderStyles;

      case 'rectangle':
        return rectAngleImageBorderStyles;

      default:
        return circleImageBorderStyles;
    }
  };

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      play = _React$useState2[0],
      setPlay = _React$useState2[1];

  var url = play ? "https://www.youtube.com/embed/".concat(youTubeVideoId, "?autoplay=1") : "https://www.youtube.com/embed/".concat(youTubeVideoId);

  var buttonVariant = function buttonVariant() {
    if (buttonType === 'Secondary Default') {
      return isDark ? 'Secondary High Contrast' : buttonType;
    } else {
      return isDark ? 'Tertiary High Contrast' : buttonType;
    }
  };

  var service = React.createElement(Box, {
    display: "flex",
    flexDirection: isSmall ? 'column' : direction,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    sx: {
      backgroundColor: "backgrounds.".concat(backgroundColor),
      borderRadius: '8px',
      padding: isSmall ? renderAsCards ? 'unset' : '53px 53px' : renderAsCards ? '53px 0' : '53px 103px',
      border: isSmall && renderAsCards ? '1px solid' : 'unset',
      borderColor: 'neutrals.primary',
      margin: isSmall && renderAsCards ? '30px 5px 0px 5px' : 'unset'
    }
  }, mediaType === 'Video' && React.createElement("div", {
    style: {
      maxWidth: isSmall ? '516px' : 'calc(50% - 8px)',
      width: '100%'
    }
  }, React.createElement("div", {
    style: {
      position: 'relative',
      paddingBottom: '56.25%',
      width: '100%'
    }
  }, React.createElement("video", {
    src: "".concat(video === null || video === void 0 ? void 0 : video.file.url),
    controls: false,
    muted: true,
    ref: videoRef,
    onClick: playVideoClicked,
    poster: videoImage === null || videoImage === void 0 ? void 0 : videoImage.file.url,
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0 auto',
      height: '100%',
      width: '100%',
      borderRadius: '8px',
      position: 'absolute',
      objectFit: 'cover',
      objectPosition: 'center',
      top: 0,
      left: 0,
      cursor: 'pointer'
    }
  }), React.createElement("div", {
    ref: buttonRef,
    onClick: playVideoClicked,
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 9,
      width: '53px',
      height: '53px',
      transition: 'all .3s ease',
      cursor: 'pointer'
    }
  }, React.createElement(TAGSvgIcon, {
    icon: "PlayCircleBtn",
    size: 53,
    color: "white"
  })))), mediaType === 'YouTube Video' && React.createElement("div", {
    style: {
      maxWidth: isSmall ? '516px' : 'calc(50% - 8px)',
      width: '100%'
    }
  }, React.createElement("div", {
    style: {
      position: 'relative',
      paddingBottom: '56.25%',
      width: '100%'
    }
  }, React.createElement("div", {
    style: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      zIndex: 9,
      opacity: play ? 0 : 1,
      transition: 'all .5s .5s ease',
      pointerEvents: play ? 'none' : 'auto'
    }
  }, React.createElement("img", {
    src: youTubeVideoImage === null || youTubeVideoImage === void 0 ? void 0 : youTubeVideoImage.file.url,
    alt: "alt",
    style: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      zIndex: 9,
      objectFit: 'cover',
      objectPosition: 'center',
      borderRadius: '8px'
    }
  }), React.createElement("div", {
    onClick: function onClick() {
      return setPlay(true);
    },
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 9,
      width: '53px',
      height: '53px',
      transition: 'all .3s ease',
      cursor: 'pointer'
    }
  }, React.createElement(TAGSvgIcon, {
    icon: "PlayCircleBtn",
    size: 53,
    color: "white"
  }))), React.createElement("iframe", {
    src: url,
    frameBorder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '8px'
    }
  }))), mediaType === 'Image' && React.createElement("div", {
    style: {
      position: 'relative',
      maxWidth: isSmall ? '360px' : 'calc(35% + 31px)',
      width: '100%',
      minHeight: isSmall ? '260px' : '360px',
      minWidth: isSmall ? '260px' : '360px'
    }
  }, React.createElement("div", {
    style: {
      paddingBottom: '100%'
    }
  }, !focalPointImage ? React.createElement("img", {
    src: "".concat(image === null || image === void 0 ? void 0 : image.file.url),
    style: _objectSpread({
      display: 'inline',
      margin: '0 auto',
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      objectFit: 'cover',
      objectPosition: 'center'
    }, imageLayoutStyles())
  }) : React.createElement(FocalPointImage, _objectSpread(_objectSpread({}, focalPointImage), {}, {
    style: _objectSpread({
      display: 'inline',
      margin: '0 auto',
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      objectFit: 'cover',
      objectPosition: 'center'
    }, imageLayoutStyles())
  })))), React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: isSmall ? centerAlign ? 'center' : 'left' : 'left',
    sx: {
      padding: isSmall ? '0 10px 20px 10px' : direction === 'row-reverse' ? '0 32px 0 0' : '0 0 0 32px',
      maxWidth: '522px',
      flex: 1
    }
  }, React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallBook' : 'bodyMediumBook',
    color: isDark ? 'text.light' : 'text.secondary',
    sx: {
      marginTop: isSmall ? '20px' : 0,
      marginBottom: '16px'
    }
  }, eyebrow), React.createElement(TAGTypography, {
    color: isDark ? 'primary.light' : 'primary',
    variant: "h2",
    sx: {
      marginBottom: '16px'
    }
  }, title), description !== null && description !== void 0 && description.description ? React.createElement(TAGTypography, {
    color: isDark ? 'text.light' : 'text.secondary',
    variant: isSmall ? 'bodyMediumBook' : 'bodyLargeBook',
    sx: {
      marginBottom: '20px'
    }
  }, description.description) : richTextDescription ? React.createElement(RichText, {
    content: richTextDescription,
    branding: branding,
    backgroundColor: backgroundColor,
    contained: true
  }) : null, buttonText && buttonUrl && React.createElement(Grid, {
    item: true
  }, React.createElement(TAGButton, {
    href: buttonUrl,
    buttonVariant: buttonVariant(),
    defaultButtonVariant: "Secondary Default",
    sx: {
      mb: '30px'
    }
  }, buttonText)), tc && React.createElement(TermsAndConditions, _objectSpread(_objectSpread({}, tc), {}, {
    branding: branding,
    isDark: isDark
  }))));
  return contained ? React.createElement(React.Fragment, null, service) : React.createElement(Container, {
    sx: _defineProperty({}, theme.breakpoints.down('sm'), {
      paddingLeft: '0',
      paddingRight: '0'
    })
  }, service);
};

export default Service;